import { createContext } from 'react';
//
import { superadminContextType } from '../../types';

// ----------------------------------------------------------------------

export const AuthContext = createContext({} as superadminContextType);
